import angular from 'angular'
import 'angular-scroll'

import registrationFormComponent from './registrationForm.component'

export default angular.module('app.common.registrationForm', ['duScroll'])
  .directive('registrationForm', registrationFormComponent)
